import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    breakpoint: { type: Number, default: 992 }
  }

  focus() {
    if (window.innerWidth >= this.breakpointValue) return

    requestAnimationFrame(() => {
      this.element.scrollIntoView({ behavior: "smooth", block: "start" })
    })
  }
}
